import Shop from "./Shop";

const Portfolio = () => <Shop category="Photography" />;

export default Portfolio;
